import { ArrowSwapHorizontal, Trade } from 'iconsax-react';
import { AboutRabexT, CoinT, HelpT } from '../types/types';

export const CoinsColumns: CoinT[][] = [
  [
    {
      path: true,
      icon: '/assets/coins/Car.svg',
      title: 'خرید کاردانو',
      subtitle: 'Cardano',
      link: '/price/ada'
    },
    {
      path: true,
      icon: '/assets/coins/Sol.svg',
      title: 'خرید سولانا',
      subtitle: 'Solana',
      link: '/price/sol'
    },
    {
      path: true,
      icon: '/assets/coins/Mat.svg',
      title: 'خرید متیک',
      subtitle: 'Matic',
      link: '/price/matic'
    },
    {
      path: true,
      icon: '/assets/coins/Ton.svg',
      title: 'خرید تن کوین',
      subtitle: 'TON',
      link: '/price/ton'
    }
  ],
  [
    {
      path: true,
      icon: '/assets/coins/Dogde.svg',
      title: 'خرید دوج‌کوین',
      subtitle: 'Dogecoin',
      link: '/price/doge'
    },
    {
      path: true,
      icon: '/assets/coins/Shib.svg',
      title: 'خرید شیبا',
      subtitle: 'Shiba Inu',
      link: '/price/shib'
    },
    {
      path: true,
      icon: '/assets/coins/Lite.svg',
      title: 'خرید لایت‌کوین',
      subtitle: 'Litecoin',
      link: '/price/ltc'
    },
    {
      path: true,
      icon: '/assets/coins/Cash.svg',
      title: 'خرید بیت کوین کش',
      subtitle: 'BitcoinCash',
      link: '/price/bch'
    },
    {
      path: true,
      icon: '/assets/coins/Rip.svg',
      title: 'خرید ریپل',
      subtitle: 'Ripple',
      link: '/price/xrp'
    }
  ],

  [
    {
      path: true,
      icon: '/assets/coins/Bitcoin.svg',
      title: 'خرید بیت کوین',
      subtitle: 'Bitcoin',
      link: '/price/btc'
    },
    {
      path: true,
      icon: '/assets/coins/Tether.svg',
      title: 'خرید تتر',
      subtitle: 'Tether',
      link: '/price/usdt'
    },
    {
      path: true,
      icon: '/assets/coins/Eth.svg',
      title: 'خرید اتریوم',
      subtitle: 'Ethereum',
      link: '/price/eth'
    },
    {
      path: true,
      icon: '/assets/coins/Binance.svg',
      title: 'خرید بایننس کوین',
      subtitle: 'Binance Coin',
      link: '/price/bnb'
    },
    {
      path: true,
      icon: '/assets/coins/Tron.svg',
      title: 'خرید ترون',
      subtitle: 'Tron',
      link: '/price/trx'
    }
  ]
];

export const AboutRabexColumns: AboutRabexT[][] = [
  [
    {
      path: false,
      icon: <Trade size="24" color="#3861fb" />,
      title: 'آشنایی با رابکس',
      subtitle: 'با ما بیشتر آشنا شوید',
      link: 'https://rabex.ir/about'
    },
    {
      path: false,
      icon: <ArrowSwapHorizontal size="24" color="#3861fb" />,
      title: 'تماس با رابکس',
      subtitle: 'ما به صورت ۲۴ ساعته، پاسخگوی شما هستیم.',
      link: 'https://rabex.ir/contact'
    }
  ]
];

export const HelpColumns: HelpT[][] = [
  [
    {
      path: true,
      icon: '/assets/help/Document.svg',
      title: 'پرسش‌های متداول',
      subtitle: 'پاسخ‌های کوتاه به پرسش‌های پرتکرار ',
      link: 'https://rabex.ir/faq/'
    },
    {
      path: true,
      icon: '/assets/help/Money.svg',
      title: 'درآمدزایی در رابکس',
      subtitle: 'دعوت دوستان، چالش‌های و ...',
      link: 'https://rabex.ir/earn/'
    },
    {
      path: true,
      icon: '/assets/help/Profile.svg',
      title: 'کارمزد معاملات',
      subtitle: 'کارمزد معامله در معامله حرفه‌ای و تبدیل آسان',
      link: 'https://rabex.ir/fee/'
    },
    {
      path: true,
      icon: '/assets/help/Setting.svg',
      title: 'مستندات API',
      subtitle: 'دستورالعمل‌های فراخوانی اپلیکیشن رابکس'
    },
    {
      path: true,
      icon: '/assets/help/Notification.svg',
      title: 'اطلاعیه‌ها و بروزرسانی‌ها',
      subtitle: 'اطلاعیه‌ها، بروزرسانی‌ها و اخبار رابکس',
      link: 'https://rabex.ir/announcements'
    }
  ],
  [
    {
      path: false,
      icon: <Trade size="24" color="#3861fb" />,
      title: 'راهنمای معامله حرفه‌ای',
      subtitle: 'معامله در پلتفرم P2P',
      link: 'https://rabex.ir/help/spot/'
    },
    {
      path: false,
      icon: <ArrowSwapHorizontal size="24" color="#3861fb" />,
      title: 'راهنمای تبدیل سریع',
      subtitle: 'تبدیل رمزارزها به یکدیگر',
      link: 'https://rabex.ir/help/convertor/'
    },
    {
      path: true,
      icon: '/assets/help/Circle.svg',
      title: 'راهنمای احراز هویت',
      subtitle: 'نحوه انجام احراز هویت سطح ۱ و ۲',
      link: 'https://rabex.ir/help/account/kyc/'
    },
    {
      path: true,
      icon: '/assets/help/Wallet.svg',
      title: 'راهنمای کیف پول',
      subtitle: 'واریز و برداشت تومان و ارز دیجیتال',
      link: 'https://rabex.ir/help/wallet/'
    },
    {
      path: true,
      icon: '/assets/help/Profile.svg',
      title: 'راهنمای حساب کاربری',
      subtitle: 'تنظیمات امنیتی، شناسایی ۲عاملی و ...',
      link: 'https://rabex.ir/help/account/'
    },
    {
      path: true,
      icon: '/assets/help/Chart.svg',
      title: 'راهنمای سطوح حساب کاربری',
      subtitle: 'سطح کاربری و فی معامله‌ در هر سطح',
      link: 'https://rabex.ir/fee/'
    }
  ]
];

export const Items = [
  {
    title: 'خرید ارز دیجیتال',
    submenu: CoinsColumns
  },
  {
    title: 'معامله حرفه‌ای',
    submenu: false,
    blank: false,
    link: 'https://p.rabex.ir/fa/trade/USDTTMN'
  },
  {
    title: 'تبدیل سریع',
    submenu: false,
    blank: false,
    link: 'https://p.rabex.ir/fa/convert'
  },
  {
    title: 'قیمت ارز دیجیتال',
    submenu: false,
    blank: false,
    link: 'https://rabex.ir/price'
  },
  {
    title: 'آکادمی',
    submenu: false,
    blank: true,
    link: 'https://rabex.ir/academy/'
  },
  {
    title: 'راهنما',
    submenu: HelpColumns,
    blank: false,
    link: 'https://rabex.ir/help/'
  },
  {
    title: 'درباره رابکس',
    submenu: AboutRabexColumns,
    blank: false,
    link: 'https://rabex.ir/about'
  }
].filter(Boolean) as Array<any>;
